import axiosInstance from "../config/axiosInterceptor";

export async function postStatus({
  objectCodeList = null,
  nodeList = null,
} = {}) {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);

  const payload = {
    start: 0,
    end: currentTimeInSeconds,
    nodeList: nodeList,
    dTypeList: null,
    objectCodeList: objectCodeList,
    objectCodeValueFilterStringList: null,
  };

  return await axiosInstance.post("/api/Status", payload);
}

export default postStatus;
